<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="订单编号：">
            <el-input v-model="searchForm.orderNumber" placeholder="请输入订单编号" clearable size="small" />
          </el-form-item>
        
          <el-form-item label="用户信息：">
            <el-input v-model="searchForm.userNameOrPhone" placeholder="请输入用户姓名/手机号" clearable size="small" />
          </el-form-item>
          <el-form-item label="身份：">
            <el-select v-model="searchForm.CLevel" placeholder="请选择" clearable size="small">
              <el-option label="研修班" :value="6"></el-option>
              <el-option label="体验班" :value="7"></el-option>
              <el-option label="普通用户" :value="8"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="业务员：">
            <el-select v-model="searchForm.ywId" filterable placeholder="请选择" clearable size="small">
              <el-option label="营销总监" :value="1"></el-option>
              <el-option label="营销经理" :value="2"></el-option>
              <el-option label="大区经理" :value="3"></el-option>
              <el-option label="地区经理" :value="4"></el-option>
              <el-option label="县区经理" :value="5"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否有奖励：">
            <el-select v-model="searchForm.isReward" placeholder="请选择" clearable size="small">
              <el-option label="有奖励" :value="1"></el-option>
              <el-option label="无奖励" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="入账账户：">
            <el-select v-model="searchForm.accountType" placeholder="请选择" clearable size="small">
              <el-option label="主账户" :value="1"></el-option>
              <el-option label="子账户" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态：">
            <el-select v-model="searchForm.orderStatus" placeholder="请选择" clearable size="small">
              <el-option label="待支付" :value="1"></el-option>
              <el-option label="已支付" :value="2"></el-option>
              <el-option label="取消支付" :value="3"></el-option>
              <el-option label="支付失败" :value="4"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="充值类型：">
            <el-select v-model="searchForm.rechargeType" placeholder="请选择" clearable size="small">
              <el-option
                v-for="item in rechargeTypeOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="充值账户：">
            <el-select v-model="searchForm.mainId" placeholder="请选择" clearable size="small">
              <el-option label="主账号" :value="0"></el-option>
              <el-option label="子账号" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="充值方式：">
            <el-select v-model="searchForm.dataSource" placeholder="请选择" clearable size="small">
              <el-option label="APP充值" :value="4"></el-option>
              <el-option label="线下充值" :value="5"></el-option>
              <el-option label="自己升级" :value="1"></el-option>
              <el-option label="老师升级" :value="2"></el-option>
              <el-option label="后台升级" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="充值时间：">
            <el-date-picker v-model="searchForm.times" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="confirmTime"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-button type="primary" plain size="mini" @click="handleDownload">导出</el-button>
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus">充值金额</el-button>
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange">
        <el-table-column label="订单编号" prop="orderNumber" align="center" width="160">
          <template slot-scope="{row}">
            <el-link type="primary" @click="handleShow(row)">{{row.orderNumber}}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="充值类型" prop="rechargeType" align="center" width="200"></el-table-column>
        <el-table-column label="用户信息" prop="name" align="center">
          <template slot-scope="{row}">
            <div>
              <span style="display: block;">{{ row.userName }}</span>
              <span style="display: block;">{{ row.userPho }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="身份" prop="clevel" align="center">
          <template slot-scope="{row}">
            <span v-if="row.orderType === 1">{{ row.businessType==1?'体验班':row.businessType==2?'研修班':'' }}</span>
            <span v-else>{{ row.clevel==6?'研修班':row.clevel==7?'体验班':'普通用户' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="充值账户" prop="mainId" align="center">
          <template slot-scope="{row}">
            <span>{{ row.mainId==0?'主账号':'子账号' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="入账账户" prop="accountType" align="center">
          <template slot-scope="{row}">
            <span>{{ row.accountType==1?'主账户':'子账户' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="发展业务线" prop="serviceLine" align="center" width="200"></el-table-column>
        <el-table-column label="充值方式" prop="dataSource" align="center">
          <template slot-scope="{row}">
            <span>{{dataSourceTxt[row.dataSource]}}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付方式" prop="payType" align="center">
          <template slot-scope="{row}">
            <span>{{ row.payType==1?'支付宝':row.payType==2?'微信':'-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="orderStatusTxt" align="center">
          <template slot-scope="{row}">
            <span>{{orderStatusTxt[row.orderStatus]}}</span>
          </template>
        </el-table-column>
        <el-table-column label="充值金额" prop="orderAmount" align="center"></el-table-column>
        <el-table-column label="充值用户区域" prop="regionName" align="center" width="200"></el-table-column>
        <el-table-column label="支付凭证" prop="payVoucherUrl" align="center">
          <template slot-scope="{row}">
            <span class="imgs" v-if="row.payVoucherUrl && row.payVoucherUrl.length">
              <el-image style="width: 50px; height: 50px" :src="row.payVoucherUrl.split(',')[0]" :preview-src-list="row.payVoucherUrl.split(',')"></el-image>
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="赠送奖励类型" prop="giveType" align="center" width="200">
          <template slot-scope="{row}">
            <span>{{ row.giveType==2?'商品：'+row.goodsName:row.giveType==1?'零售价：'+row.xiaoduMoney:'-' }}</span>
          </template>
        </el-table-column>

        <el-table-column label="充值时间" prop="createdTime" sortable align="center" width="160"></el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="160" >
          <template slot-scope="{row}">
            <el-button type="text" @click="handleShow(row)">详情</el-button>
            <el-button type="text" @click="handleLog(row)" v-if="row.dataSource===5">日志记录</el-button>
           
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <rechargeRecord-add ref="rechargeRecordAdd" @created="doQueryList({})" :popType="popType" />
  </div>
</template>

<script>
import rechargeRecordAdd from './add'
import rechargeRecordApi from '@/api/recharge/rechargeRecord'
import sysDataconstantApi from '@/api/config/sysDataconstant'
import Pagination from '@/components/Pagination'
export default {
  components: {
    Pagination,
    rechargeRecordAdd
  },
  data() {
    return {
      popType: 0, //0:新增 1:编辑
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10
      },
      searchForm: {
        orderNumber: '',
        userNameOrPhone: '',
        CLevel: '',
        ywId: '',
        accountType: '',
        isReward: '',
        mainId: '',
        endTime: '',
        startTime: '',
        times: '',
        rechargeType: ''
      },
      orderStatusTxt: ['', '待支付', '已支付', '取消支付', '支付失败'],
      dataSourceTxt: ['','自己升级','老师升级','后台升级','App充值','线下充值'],
      rechargeTypeOptions: []
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
    this.getRechargeTypeOptions()
  },
  methods: {
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({
        pageNo: 1
      })
    },
    /**
     * 重置
     */
    handleFilter() {
      this.searchForm = {
        orderNumber: '',
        userNameOrPhone: '',
        CLevel: '',
        ywId: '',
        accountType: '',
        isReward: '',
        mainId: '',
        endTime: '',
        startTime: '',
        times: null
      }

      this.doQueryList({
        pageNo: 1
      })
    },
    /**
     * 获取列表数据
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }

      let params = { ...this.query }
      if (this.searchForm.orderNumber !== '') params.orderNumber = this.searchForm.orderNumber
      if (this.searchForm.userNameOrPhone !== '') params.userNameOrPhone = this.searchForm.userNameOrPhone
      if (this.searchForm.accountType !== '') params.accountType = this.searchForm.accountType
      if (this.searchForm.CLevel !== '') params.CLevel = this.searchForm.CLevel
      if (this.searchForm.ywId !== '') params.ywId = this.searchForm.ywId
      if (this.searchForm.isReward !== '') params.isReward = this.searchForm.isReward
      if (this.searchForm.mainId !== '') params.mainId = this.searchForm.mainId
      if (this.searchForm.dataSource !== '') params.dataSource = this.searchForm.dataSource
      if (this.searchForm.orderStatus !== '') params.orderStatus = this.searchForm.orderStatus
      if (this.searchForm.times) {
        params.startTime = this.searchForm.times[0]
        params.endTime = this.searchForm.times[1]
      }

      this.listLoading = true
      return rechargeRecordApi.fetchList(params)
        .then(res => {
          // res.data.list.forEach(item => {
          //   item.showTime = item.isLimit ? `${item.startTime.substring(0,16)}--${item.endTime.substring(0,16)}` : '-';
          //   item.times = item.isLimit ? [item.startTime,item.endTime] : '';
          // })
          this.list = res.data.list
          this.total = res.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.popType = 0
      this.$refs.rechargeRecordAdd.handleCreate(row)
    },
    /**
     * 打开查看表单
     */
    handleShow(row) {
      this.$emit('handleShow', row, 2)
    },
    /**
     * 导出
     */
    handleDownload() {
      this.$router.push("/export/list?code=tuitionListExport")
    },
    /**
     * 日志记录
     */
    handleLog(row) {
      this.$router.push("/log/log?type=131&id=" + row.id)
    }
  }
}
</script>
<style lang="scss" scoped>
.imgs {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  & > img {
    max-width: 80px;
    height: 36px;
    border-radius: 4px;
    margin-right: 5px;
    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
